import React from 'react';
import { Link } from 'react-router-dom';

const Disclaimer = () => {
  return (
    <>
      {/* Custom Cursors */}
      <div className="custom-cursor-one"></div>
      <div className="custom-cursor-two"></div>

      {/* inner-page hero start */}
      <div 
        className="inner-page-hero" 
        style={{ backgroundImage: 'url(/assets/images/background/bg3.png)' }}
      >
        <div className="container">
          <div className="hero-heading-title">
            <h2>Disclaimer</h2>
          </div>
          <ul className="bradcrumb">
            <li><a href="/">Home</a></li>
            <li><Link to="#">Disclaimer</Link></li>
          </ul>
        </div>
      </div>
      {/* inner-page hero end */}
       <br/> <br/> <br/>

    </>
  );
};

export default Disclaimer;